jQuery( document ).ready( function ( $ ) {

	// if (window.innerWidth < 1023) {
	// 	let heightBlock = $('.slider-with-rows_list_item').length;
	// 	$('.block-slider-with-rows').css('height',`${heightBlock * 100}vh`);
	//
	// 	$('.slider-with-rows_list').slick({
	// 		dots: false,
	// 		infinite: false,
	// 		fade: true,
	// 		cssEase: 'linear',
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1
	// 	});
	//
	//
	// 	$('.slider-with-rows_list').on('wheel scroll', (function(e) {
	// 		if (e.originalEvent.deltaY < 0) {
	// 			$(this).slick('slickPrev');
	// 		} else if (e.originalEvent.deltaY > 0) {
	// 			$(this).slick('slickNext');
	// 		}
	// 	}));
	// } else {
		let allLeftItems = document.querySelectorAll('.left-part');
		let allRightItems = document.querySelectorAll('.right-part');
		let maxHeight = 0;
		allLeftItems.forEach(elem => {
			if (elem.clientHeight > maxHeight) {
				maxHeight = elem.clientHeight;
			}
			var controller = new ScrollMagic.Controller();
			var tween = TweenMax.to(elem, 1, {className: "+=element-show"});
			var scene = new ScrollMagic.Scene({triggerElement: elem, duration: 150, offset: -300})
				.setTween(tween)
				.addTo(controller);
			$(document).on('accessibilityPreEvent', function (e) {
				if ( e.originalEvent.detail['without-animation'] ) {
					scene.destroy();
					elem.classList.add('element-show');
				} else {
					elem.classList.remove('element-show');
					scene = new ScrollMagic.Scene({triggerElement: elem, duration: 150, offset: -300})
						.setTween(tween)
						.addTo(controller);
				}
			});
		});

		allRightItems.forEach(elem2 => {
			if (elem2.clientHeight > maxHeight) {
				maxHeight = elem2.clientHeight;
			}
			var controller2 = new ScrollMagic.Controller();
			var tween2 = TweenMax.to(elem2, 1, {className: "+=element-show"});
			var scene2 = new ScrollMagic.Scene({triggerElement: elem2, duration: 150, offset: -300})
				.setTween(tween2)
				.addTo(controller2);
			$(document).on('accessibilityPreEvent', function (e) {
				if ( e.originalEvent.detail['without-animation'] ) {
					scene2.destroy();
					elem2.classList.add('element-show');
				} else {
					elem2.classList.remove('element-show');
					scene2 = new ScrollMagic.Scene({triggerElement: elem2, duration: 150, offset: -300})
						.setTween(tween2)
						.addTo(controller2);
				}
			});
		});

		allLeftItems.forEach(elem => {
			elem.style.height = maxHeight + "px";
		});
		allRightItems.forEach(elem2 => {
			elem2.style.height = maxHeight + "px";
		});
	// }
});